
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import divScroll from "@/components/div-scroll/div-scroll.vue";
import { objAny } from "@/common/common-interface";
import { State } from "vuex-class";
@Component({
  components: {
    "pi-div-scroll": divScroll
  }
})
export default class PiMenu extends Vue {
  @Prop({ default: "" }) private menuId!: string;
  @Prop({ default: true }) private isCollapse!: boolean;
  @State("sys") sys!: objAny;
  @Watch("menuId")
  @Watch("sys.menuList")
  getVisible() {
    this.openNames = [this.getTowMenu(this.menuId)];
  }

  private theme2 = "light";
  private openNames: string[] = [];
  private menuList: string[] = [];

  private menuShow = false;
  public zoomClick(): void {
    this.$emit("collapse");
  }

  public getTowMenu(key: string): string {
    const arr = key.split("-");
    return arr[0] + "-" + arr[1];
  }

  public smallMenuClick(item: objAny): void {
    if (!item.children || item.children.length == 0) {
      if (this["$route"].path != item.url) {
        this["$router"].push(item.url);
      }
    } else {
      item.isOpen = !item.isOpen;
    }
  }

  initMenuList() {
    const menuList = JSON.parse(JSON.stringify(this.sys.menuList));
    menuList.map((item: objAny) => {
      item.isOpen = false;
      if (item.children && item.children.length > 0) {
        item.children.map((child: objAny) => {
          child.isOpen = false;
        });
      }
    });
    this.menuList = menuList;
  }

  mounted() {
    this.initMenuList();
  }
}
